import { Channels } from './pages';

export default {
  key: 'channels',
  path: '/',
  exact: true,
  component: Channels,
};
